import React, { Component } from "react";
import classes from "./assignServices.module.css";
import axios from "../../../../axios-order";
import Button from "@material-ui/core/Button";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import UploadQuotaModal from "./UploadQuotaModal";
import Checkbox from "@material-ui/core/Checkbox";
import Appbar from "../../../../components/appBar/appBar";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import { ValidatorForm } from "react-material-ui-form-validator";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import InputField from "../../../../components/ui/inputField";
import SelectField from "../../../../components/ui/select";
import ValidatedDatePicker from "../../../../components/ui/DatePicker";
import Footer from "../../../../components/footer/footer";
import CircularProgress from "@material-ui/core/CircularProgress";
import ServicesTable from "./servicesTable";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {
  FormControl, 
  InputLabel,
} from "@mui/material";

const useStyles = makeStyles({
  list: {
    width: 1050,
    height: 1000,
  },
  fullList: {
    width: "auto",
  },
});

class AssignServices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      entityDetails: {},
      business_entity_id: localStorage.getItem("business_mgmt_entity_id"),

      ID_ServiceData: {},
      showIDData: false,
      showIDFromDate: true,
      showIDToDate: true,
      showIDReason: false,

      IC_ServiceData: {},
      showICData: false,
      showICFromDate: true,
      showICToDate: true,
      showICReason: false,

      ARC_ServiceData: {},
      showARCData: false,
      showARCFromDate: true,
      showARCToDate: true,
      showARCReason: false,
      ARC_radioButton_value: "",
      loader: false,
      cinLoader: false,
      panLoader: false,
      radiaButtonErrorMsg: "",
      requested_categories: "",
      caFirmEntities: [],
      selectedCaFirmEntity: "",
      showUploadQuotaModal: false,
      entitiesUnderCaFirm: [],
      showEntitiesUnderCaFirmModal: false,
      entitiesUnderCaFirmMessage: "",
      financialYearsList: [],
      receivables26ASSelectedYears: [],
      receivables26ASCurrentYear: "",
    };
  }

  componentDidMount = () => {
    if (this.state.showIDData === true) {
      this.setState((prevState) => ({
        ID_ServiceData: {
          ...prevState.ID_ServiceData,
          service_id: 1,
        },
      }));
    } else if (this.state.showICData === true) {
    } else if (this.state.ARC_radioButton_value === "3") {
    } else if (this.state.ARC_radioButton_value === "4") {
    }


    axios
      .get(`/get_entity_data/${this.state.business_entity_id}`)
      .then((res) => {
        this.setState({
          entityDetails: res.data.records,
        });
        
     
        if (res.data.records.is_ca_firm_or_not === false) {
          this.fetchCaFirmEntities();
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(
        `/cws_services/get_entity_services/${localStorage.getItem(
          "business_mgmt_entity_id"
        )}`
      )
      .then((res) => {
        this.setState({ requested_categories: res.data.requested_categories });
      });
    // ---End---
    // axios
    //   .get(`/get_entity_services/${this.state.business_entity_id}`)
    //   .then((res) => {
    //     this.setState({
    //       ID_ServiceData: res.data.records[0],
    //       IC_ServiceData: res.data.records[1],
    //       ARC_ServiceData: res.data.records[2],
    //     });
    //     if (
    //       res.data.records[0].status === "Approved" ||
    //       res.data.records[0].status === "Hold" ||
    //       res.data.records[0].status === "Rejected" ||
    //       res.data.records[0].status === "Stop" ||
    //       res.data.records[0].status === "Pending" ||
    //       res.data.records[0].status === "Not Requested"
    //     ) {
    //       this.setState((prevState) => ({
    //         ID_ServiceData: {
    //           ...prevState.ID_ServiceData,
    //           service_id: 1,
    //         },
    //         showIDData: true,
    //       }));

    //       if (res.data.records[0].status === "Pending") {
    //         this.setState({
    //           showIDFromDate: false,
    //           showIDToDate: false,
    //           showIDReason: false,
    //         });
    //       } else if (res.data.records[0].status === "Not Requested") {
    //         this.setState({
    //           showIDFromDate: false,
    //           showIDToDate: false,
    //           showIDReason: false,
    //           showICData: false,
    //         });
    //       } else if (res.data.records[0].status === "Rejected") {
    //         this.setState({
    //           showIDFromDate: false,
    //           showIDToDate: false,
    //           showIDReason: true,
    //         });
    //       } else if (
    //         res.data.records[0].status === "Hold" ||
    //         res.data.records[0].status === "Stop"
    //       ) {
    //         this.setState({
    //           showIDFromDate: true,
    //           showIDToDate: false,
    //           showIDReason: false,
    //         });
    //       }
    //     }
    //     if (
    //       res.data.records[1].status === "Approved" ||
    //       res.data.records[1].status === "Hold" ||
    //       res.data.records[1].status === "Rejected" ||
    //       res.data.records[1].status === "Stop" ||
    //       res.data.records[1].status === "Pending" ||
    //       res.data.records[1].status === "Not Requested"
    //     ) {
    //       this.setState((prevState) => ({
    //         IC_ServiceData: {
    //           ...prevState.IC_ServiceData,
    //           service_id: 2,
    //         },
    //         showICData: true,
    //       }));

    //       if (res.data.records[1].status === "Pending") {
    //         this.setState({
    //           showICFromDate: false,
    //           showICToDate: false,
    //           showICReason: false,
    //         });
    //       } else if (res.data.records[1].status === "Not Requested") {
    //         this.setState({
    //           showICFromDate: false,
    //           showICToDate: false,
    //           showICReason: false,
    //           showICData: false,
    //         });
    //       } else if (res.data.records[1].status === "Rejected") {
    //         this.setState({
    //           showICFromDate: false,
    //           showICToDate: false,
    //           showICReason: true,
    //         });
    //       } else if (
    //         res.data.records[1].status === "Hold" ||
    //         res.data.records[1].status === "Stop"
    //       ) {
    //         this.setState({
    //           showICFromDate: true,
    //           showICToDate: false,
    //           showICReason: false,
    //         });
    //       }
    //     }
    //     if (
    //       res.data.records[2].status === "Approved" ||
    //       res.data.records[2].status === "Hold" ||
    //       res.data.records[2].status === "Rejected" ||
    //       res.data.records[2].status === "Stop" ||
    //       res.data.records[2].status === "Pending" ||
    //       res.data.records[2].status === "Not Requested"
    //     ) {
    //       this.setState({
    //         showARCData: true,
    //       });
    //       // radio button--
    //       if (res.data.records[2].service_id === "ARC Basic (ARC only)") {
    //         this.setState((prevState) => ({
    //           ARC_ServiceData: {
    //             ...prevState.ARC_ServiceData,
    //             service_id: 3,
    //           },
    //           ARC_radioButton_value: "3",
    //         }));
    //       } else {
    //         this.setState((prevState) => ({
    //           ARC_ServiceData: {
    //             ...prevState.ARC_ServiceData,
    //             service_id: 4,
    //           },
    //           ARC_radioButton_value: "4",
    //         }));
    //       }
    //       // ---End---

    //       if (res.data.records[2].status === "Pending") {
    //         this.setState({
    //           showARCFromDate: false,
    //           showARCToDate: false,
    //           showARCReason: false,
    //         });
    //       } else if (res.data.records[2].status === "Rejected") {
    //         this.setState({
    //           showARCFromDate: false,
    //           showARCToDate: false,
    //           showARCReason: true,
    //         });
    //       } else if (
    //         res.data.records[2].status === "Hold" ||
    //         res.data.records[2].status === "Stop"
    //       ) {
    //         this.setState({
    //           showARCFromDate: true,
    //           showARCToDate: false,
    //           showARCReason: false,
    //         });
    //       }

    //       if (res.data.records[2].status === "Not Requested") {
    //         this.setState({
    //           showARCFromDate: false,
    //           showARCToDate: false,
    //           showARCReason: false,
    //           showARCData: false,
    //           ARC_radioButton_value: "",
    //         });
    //       }
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    // ---End--
  };

   fetchCaFirmEntities = () => {
    const payload = {
      business_entity_id: parseInt(this.state.business_entity_id)
    };
    
    console.log('Fetching CA firm entities with payload:', payload);
    
    axios
      .post('/ca_firm_entity_list', payload)
      .then((res) => {
        console.log('CA firm entities response:', res.data);

        let records = res.data.records || [];
        const isUnderCaFirm = res.data.is_under_ca_firm || "";
        const caFirmEntityId = res.data.ca_firm_entity_id || "";

        if (records.length > 0 && typeof records[0] === 'string') {
          console.log('Converting string array to object array');
          records = records.map((name, index) => ({
            business_entity_id: name,
            entity_name: name
          }));
        }
        
        console.log('Setting caFirmEntities:', records);
        console.log('Setting selectedCaFirmEntity:', isUnderCaFirm);
        
        this.setState({
          caFirmEntities: records,
          selectedCaFirmEntity: caFirmEntityId,  
        }, () => {
          console.log('State updated. caFirmEntities:', this.state.caFirmEntities);
          console.log('State updated. selectedCaFirmEntity:', this.state.selectedCaFirmEntity);
        });
      })
      .catch((error) => {
        console.error('Error fetching CA firm entities:', error);
        toast.error("Error loading CA firm entities.", {
          autoClose: 3000,
          progress: 0,
        });
      });
  };

  handleReceivablesYearChange = (event) => {
    const selectedYear = event.target.value;
    if (!selectedYear) return;

    this.setState((prevState) => {
      if (prevState.receivables26ASSelectedYears.includes(selectedYear)) {
        return { receivables26ASCurrentYear: "" };
      }
      return {
        receivables26ASSelectedYears: [
          ...prevState.receivables26ASSelectedYears,
          selectedYear,
        ],
        receivables26ASCurrentYear: "",
      };
    });
  };

  handleOpenEntitiesUnderCaFirm = () => {
    const caFirmEntityId = this.state.entityDetails.business_entity_id;

    axios
      .get(`/list_entities_under_ca_firm/${caFirmEntityId}`)
      .then((res) => {
        console.log("API response:", res.data);
        const entities = res.data.data || [];
        this.setState({
          entitiesUnderCaFirm: entities,
          entitiesUnderCaFirmMessage: "",
          showEntitiesUnderCaFirmModal: true,
        }, () => {
          console.log("Modal state:", this.state.showEntitiesUnderCaFirmModal);
          console.log("Entities:", this.state.entitiesUnderCaFirm);
        });
      })
      .catch((error) => {
        const message =
          error?.response?.data?.message || "Error fetching entities under CA firm.";
        this.setState({
          entitiesUnderCaFirm: [],
          showEntitiesUnderCaFirmModal: true,
          entitiesUnderCaFirmMessage: message,
        });
      });
  };

  handleCloseEntitiesUnderCaFirm = () => {
    this.setState({
      showEntitiesUnderCaFirmModal: false,
      entitiesUnderCaFirm: [],
      entitiesUnderCaFirmMessage: "",
      entitiesSearchQuery: "",
    });
  };

  handleRemoveReceivablesYear = (yearToRemove) => {
    this.setState((prevState) => ({
      receivables26ASSelectedYears: prevState.receivables26ASSelectedYears.filter(
        (y) => y !== yearToRemove
      ),
    }));
  };

  handleIDCheckBoxChange = (event) => {
    const checked = event.target.checked;
    if (checked) {
      this.setState((prevState) => ({
        ID_ServiceData: {
          ...prevState.ID_ServiceData,
          service_id: 1,
        },
        showIDData: checked,
        showIDFromDate: false,
        showIDToDate: false,
        showIDReason: false,
      }));
    } else {
      this.setState((prevState) => ({
        ID_ServiceData: {
          ...prevState.ID_ServiceData,
          service_id: 2,
          status: "Not Requested",
        },
        showIDData: checked,
      }));
    }
  };

  handleICCheckBoxChange = (event) => {
    const checked = event.target.checked;
    if (checked) {
      this.setState((prevState) => ({
        IC_ServiceData: {
          ...prevState.IC_ServiceData,
          service_id: 2,
        },
        showICData: checked,
        showICFromDate: false,
        showICToDate: false,
        showICReason: false,
      }));
    } else {
      this.setState((prevState) => ({
        IC_ServiceData: {
          ...prevState.IC_ServiceData,
          service_id: 2,
          status: "Not Requested",
        },
        showICData: checked,
      }));
    }

    this.setState({
      showICData: checked,
    });
  };

  handleARCCheckBoxChange = (event) => {
    const checked = event.target.checked;
    if (checked) {
      this.setState((prevState) => ({
        ARC_ServiceData: {
          ...prevState.ARC_ServiceData,
          service_id: 3,
        },
        showARCData: checked,
        showARCFromDate: false,
        showARCToDate: false,
        showARCReason: false,
      }));
    } else {
      this.setState((prevState) => ({
        ARC_ServiceData: {
          ...prevState.ARC_ServiceData,
          service_id: 2,
          status: "Not Requested",
        },
        showARCData: checked,
        radiaButtonErrorMsg: "",
        ARC_radioButton_value: "",
      }));
    }
  };

  // ---input && select field ---
  handleEntityServiceChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;
    if (name === "ID_status") {
      if (value === "Rejected") {
        this.setState((prevState) => ({
          ID_ServiceData: {
            ...prevState.ID_ServiceData,
            from_date: null,
            to_date: null,
            reason: null,
          },
          showIDReason: true,
          showIDToDate: false,
          showIDFromDate: false,
        }));
      } else if (value === "Hold" || value === "Stop") {
        this.setState((prevState) => ({
          ID_ServiceData: {
            ...prevState.ID_ServiceData,
            from_date: null,
            to_date: null,
            reason: null,
          },
          showIDToDate: false,
          showIDFromDate: true,
          showIDReason: false,
        }));
      } else if (value === "Approved") {
        this.setState((prevState) => ({
          ID_ServiceData: {
            ...prevState.ID_ServiceData,
            from_date: null,
            to_date: null,
            reason: null,
          },
          showIDToDate: true,
          showIDFromDate: true,
          showIDReason: false,
        }));
      } else if (value === "Pending") {
        this.setState((prevState) => ({
          ID_ServiceData: {
            ...prevState.ID_ServiceData,
            from_date: null,
            to_date: null,
            reason: null,
          },
          showIDToDate: false,
          showIDFromDate: false,
          showIDReason: false,
        }));
      } else {
        this.setState({
          showIDToDate: false,
          showIDFromDate: false,
          showIDReason: false,
        });
      }
      // ------

      this.setState((prevState) => ({
        ID_ServiceData: {
          ...prevState.ID_ServiceData,
          status: String(value),
        },
      }));
    } else if (name === "ID_reason") {
      this.setState((prevState) => ({
        ID_ServiceData: {
          ...prevState.ID_ServiceData,
          reason: String(value),
        },
      }));
    } else if (name === "IC_status") {
      // ------
      if (value === "Rejected") {
        this.setState((prevState) => ({
          IC_ServiceData: {
            ...prevState.IC_ServiceData,
            from_date: null,
            to_date: null,
            reason: null,
          },
          showICReason: true,
          showICToDate: false,
          showICFromDate: false,
        }));
      } else if (value === "Hold" || value === "Stop") {
        this.setState((prevState) => ({
          IC_ServiceData: {
            ...prevState.IC_ServiceData,
            from_date: null,
            to_date: null,
            reason: null,
          },
          showICToDate: false,
          showICFromDate: true,
          showICReason: false,
        }));
      } else if (value === "Approved") {
        this.setState((prevState) => ({
          IC_ServiceData: {
            ...prevState.IC_ServiceData,
            from_date: null,
            to_date: null,
            reason: null,
          },
          showICToDate: true,
          showICFromDate: true,
          showICReason: false,
        }));
      } else {
        this.setState({
          showICToDate: false,
          showICFromDate: false,
          showICReason: false,
        });
      }
      // -----
      this.setState((prevState) => ({
        IC_ServiceData: {
          ...prevState.IC_ServiceData,
          status: String(value),
        },
      }));
    } else if (name === "ic_reason") {
      this.setState((prevState) => ({
        IC_ServiceData: {
          ...prevState.IC_ServiceData,
          reason: String(value),
        },
      }));
    } else if (name === "arc_status") {
      // ------
      if (value === "Rejected") {
        this.setState((prevState) => ({
          ARC_ServiceData: {
            ...prevState.ARC_ServiceData,
            from_date: null,
            to_date: null,
            reason: null,
          },
          showARCReason: true,
          showARCToDate: false,
          showARCFromDate: false,
        }));
      } else if (value === "Hold" || value === "Stop") {
        this.setState((prevState) => ({
          ARC_ServiceData: {
            ...prevState.ARC_ServiceData,
            from_date: null,
            to_date: null,
            reason: null,
          },
          showARCToDate: false,
          showARCFromDate: true,
          showARCReason: false,
        }));
      } else if (value === "Approved") {
        this.setState((prevState) => ({
          ARC_ServiceData: {
            ...prevState.ARC_ServiceData,
            from_date: null,
            to_date: null,
            reason: null,
          },
          showARCToDate: true,
          showARCFromDate: true,
          showARCReason: false,
        }));
      } else {
        this.setState({
          showARCToDate: false,
          showARCFromDate: false,
          showARCReason: false,
        });
      }
      // -----
      this.setState((prevState) => ({
        ARC_ServiceData: {
          ...prevState.ARC_ServiceData,
          status: String(value),
        },
      }));
    } else {
      this.setState((prevState) => ({
        ARC_ServiceData: {
          ...prevState.ARC_ServiceData,
          reason: String(value),
        },
      }));
    }
  };

  setFromYearValues = () => {
    const year = new Date().getFullYear();
    const list = [];
    for (let i = year - 10; i <= year + 1; i++) {
      list.push({ id: `${i}-${i + 1}`, year: `${i}-${i + 1}` });
    }
    this.setState({ financialYearsList: list });
  };

  handleFromDateChange(v, name) {
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();

      if (name === "ID_from_date") {
        this.setState((prevState) => ({
          ID_ServiceData: {
            ...prevState.ID_ServiceData,
            from_date: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
          },
        }));
      } else if (name === "ic_from_date") {
        this.setState((prevState) => ({
          IC_ServiceData: {
            ...prevState.IC_ServiceData,
            from_date: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
          },
        }));
      } else {
        this.setState((prevState) => ({
          ARC_ServiceData: {
            ...prevState.ARC_ServiceData,
            from_date: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
          },
        }));
      }
    } else {
      return false;
    }
  }

  // ---To date change for service---
  handleToDateChange(v, name) {
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();
      if (name === "ID_to_date") {
        this.setState((prevState) => ({
          ID_ServiceData: {
            ...prevState.ID_ServiceData,
            to_date: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
          },
        }));
      } else if (name === "ic_to_date") {
        this.setState((prevState) => ({
          IC_ServiceData: {
            ...prevState.IC_ServiceData,
            to_date: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
          },
        }));
      } else {
        this.setState((prevState) => ({
          ARC_ServiceData: {
            ...prevState.ARC_ServiceData,
            to_date: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
          },
        }));
      }
    } else {
      return false;
    }
  }

  // ---Assign service submit hanlder---
  AssignServiceSubmitHandler = () => {
    const dataObject = {
      ID: this.state.ID_ServiceData,
      IC: this.state.IC_ServiceData,
      ARC: this.state.ARC_ServiceData,
    };
    axios
      .post(
        `/post_entity_services/${this.state.business_entity_id}`,
        dataObject
      )
      .then((res) => {
        toast.success("Service successfully assigned.", {
          autoClose: 3000,
          progress: 0,
        });
      })
      .catch((error) => {
        toast.error(
          "some error occurred,Please contact system administrator!",
          {
            autoClose: 3000,
            progress: 0,
          }
        );
      });
  };

  backHanlder = () => {
    this.props.history.goBack();
  };

  handleChange = (event) => {
    // alert("1");
  };

  handleVerifyGSTIN = (event) => {
    event.preventDefault();
    this.setState({
      gstinLoader: true,
    });
    axios
      .get(`/validateGSTIN/${this.state.business_entity_id}`)
      .then((res) => {
        this.setState({
          verifyGSTIN: res.data.status,
          verifyGSTINError: res.data.message,
          gstinLoader: false,
        });
      })
      .catch((error) => {
        this.setState({
          verifyGSTINError: error.response.data.message,
          gstinLoader: false,
        });
      });
  };

  handleVerifyCIN = (event) => {
    event.preventDefault();
    this.setState({
      cinLoader: true,
    });
    axios
      .get(`/validateCIN/${this.state.business_entity_id}`)
      .then((res) => {
        this.setState({
          verifyCIN: res.data.status,
          verifyCINError: res.data.message,
          cinLoader: false,
        });
      })
      .catch((error) => {
        this.setState({
          verifyCINError: error.response.data.message,
          cinLoader: false,
        });
      });
  };

  handleVerifyPAN = (event) => {
    event.preventDefault();
    this.setState({
      panLoader: true,
    });
    axios
      .get(`/validatePAN/${this.state.business_entity_id}`)
      .then((res) => {
        this.setState({
          verifyPAN: res.data.status,
          verifyPANError: res.data.message,
          panLoader: false,
        });
      })
      .catch((error) => {
        console.log(error.response.data.message);
        this.setState({
          verifyPANError: error.response.data.message,
          panLoader: false,
        });
      });
  };

  handleDropdownChange = (event) => {
    const isCAFirm = event.target.value === "Yes";
    
    this.setState((prevState) => ({
      entityDetails: {
        ...prevState.entityDetails,
        is_ca_firm_or_not: isCAFirm,
      },
      selectedCaFirmEntity: !isCAFirm ? "" : prevState.selectedCaFirmEntity,
    }));
    
    const body = {
      'is_ca_firm_or_not': isCAFirm,
      'business_entity_id': this.state.entityDetails.business_entity_id
    };
    
    axios.post('/update_is_ca_firm_or_not', body)
      .then((res) => {
        if (isCAFirm === false) {
          this.fetchCaFirmEntities();
        }
      })
      .catch((err) => {
        console.error('Error updating CA firm status:', err);
      });
  };

  handleCaFirmEntityChange = (event) => {
    const selectedEntityId = event.target.value;
    
    console.log('Selected CA Firm Entity:', selectedEntityId);
 const selectedEntity = this.state.caFirmEntities.find(
  (entity) => entity.business_entity_id == selectedEntityId 
);

  const ca_firm_entity_name = selectedEntity ? selectedEntity.entity_name : "";
    
    this.setState({
      selectedCaFirmEntity: selectedEntityId,
    ca_firm_entity_id: selectedEntityId,
    ca_firm_entity_name: ca_firm_entity_name,
    });
  
    const body = {
    business_entity_id: this.state.entityDetails.business_entity_id,
    ca_firm_entity_id: selectedEntityId,
    ca_firm_entity_name: ca_firm_entity_name,
    };
    
    console.log('Updating CA firm entity with body:', body);
    
    axios.post('/ca_firm_entity_list', body)
      .then((res) => {
        console.log('CA firm entity update response:', res.data);
        toast.success("CA Firm entity updated successfully.", {
          autoClose: 3000,
          progress: 0,
        });
      })
      .catch((err) => {
        console.error('Error updating CA firm entity:', err);
        toast.error("Error updating CA firm entity.", {
          autoClose: 3000,
          progress: 0,
        });
      });
  };

  handleCaFirmDropdownOpen = () => {
    this.fetchCaFirmEntities();
  };

  handleOpenUploadQuota = () => {
    this.setState({ showUploadQuotaModal: true });
  };

  handleCloseUploadQuota = () => {
    this.setState({ showUploadQuotaModal: false });
  };

  render() {
    return (
      <>
        <Appbar />
        <div className={classes.AssignServicesSection}>
          {/* BACK BUTTON */}
          <button
            className="button-outlined-primary"
            variant="contained"
            size="small"
            onClick={this.backHanlder}
          >
            back
          </button>
          {/* BUSINESS ENTITY DETAILS */}

          <BoxWrapper
            boxTitle={`Entity Details : ${this.state.entityDetails.entity_name}`}
          >
            {/* Entity Details */}
            <Grid container spacing={3}>
              <Grid item xs={5}>
                <TableContainer>
                  <Table size="small" aria-label="a dense table">
                    <TableBody>
                      <TableRow>
                        <TableCell
                          style={{ paddingRight: "0px", border: "none" }}
                        >
                          Constitution :
                        </TableCell>
                        <TableCell
                          style={{ paddingLeft: "0px", border: "none" }}
                        >
                          {this.state.entityDetails.constitution_id}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          style={{
                            minWidth: 100,
                            paddingRight: "0px",
                            border: "none",
                          }}
                        >
                          Business Sector :
                        </TableCell>
                        <TableCell
                          style={{ paddingLeft: "0px", border: "none" }}
                        >
                          {this.state.entityDetails.business_sector_id}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          style={{
                            minWidth: 100,
                            paddingRight: "0px",
                            border: "none",
                          }}
                        >
                          Flat No :
                        </TableCell>
                        <TableCell
                          style={{ paddingLeft: "0px", border: "none" }}
                        >
                          {this.state.entityDetails.flat_no}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          style={{
                            minWidth: 180,
                            paddingRight: "0px",
                            border: "none",
                          }}
                        >
                          Road/Street Name :
                        </TableCell>
                        <TableCell
                          style={{ paddingLeft: "0px", border: "none" }}
                        >
                          {this.state.entityDetails.road_street_name}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          style={{
                            minWidth: 100,
                            paddingRight: "0px",
                            border: "none",
                          }}
                        >
                          Area :
                        </TableCell>
                        <TableCell
                          style={{ paddingLeft: "0px", border: "none" }}
                        >
                          {this.state.entityDetails.area}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          style={{
                            minWidth: 100,
                            paddingRight: "0px",
                            border: "none",
                          }}
                        >
                          City :
                        </TableCell>
                        <TableCell
                          style={{ paddingLeft: "0px", border: "none" }}
                        >
                          {this.state.entityDetails.city}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          style={{
                            minWidth: 100,
                            paddingRight: "0px",
                            border: "none",
                          }}
                        >
                          State :
                        </TableCell>
                        <TableCell
                          style={{ paddingLeft: "0px", border: "none" }}
                        >
                          {this.state.entityDetails.state}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          style={{
                            minWidth: 100,
                            paddingRight: "0px",
                            border: "none",
                          }}
                        >
                          Country :
                        </TableCell>
                        <TableCell
                          style={{ paddingLeft: "0px", border: "none" }}
                        >
                          {this.state.entityDetails.country}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          style={{
                            minWidth: 100,
                            paddingRight: "0px",
                            border: "none",
                          }}
                        >
                          Pincode :
                        </TableCell>
                        <TableCell
                          style={{ paddingLeft: "0px", border: "none" }}
                        >
                          {this.state.entityDetails.pincode}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          style={{
                            minWidth: 180,
                            paddingRight: "0px",
                            border: "none",
                          }}
                        >
                          Mobile Number :
                        </TableCell>
                        <TableCell
                          style={{ paddingLeft: "0px", border: "none" }}
                        >
                          {this.state.entityDetails.contact_number}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          style={{
                            minWidth: 180,
                            paddingRight: "0px",
                            border: "none",
                          }}
                        >
                          Requested Categories:
                        </TableCell>
                        <TableCell
                          style={{ paddingLeft: "0px", border: "none" }}
                        >
                          {this.state.requested_categories === null ? (
                            <span style={{ color: "red" }}>Not Requested</span>
                          ) : (
                            this.state.requested_categories
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>

              <Grid item xs={7}>
                <TableContainer>
                  <Table size="small" aria-label="a dense table">
                    <TableBody>
                      <TableRow>
                        <TableCell style={{ border: "none" }}>
                          GSTIN :{" "}
                        </TableCell>
                        <TableCell style={{ border: "none" }}>
                          {this.state.entityDetails.gst}
                        </TableCell>
                        <TableCell style={{ border: "none" }}>
                          {this.state.gstinLoader === true ? (
                            <CircularProgress size={30} thickness={5} />
                          ) : (
                            <>
                              <a
                                href="javscript:void(0)"
                                style={{ textDecoration: "none" }}
                                onClick={this.handleVerifyGSTIN}
                              >
                                {this.state.verifyGSTIN ||
                                this.state.entityDetails.is_gstin_verified === 1
                                  ? "Verified - Verify Again"
                                  : "Verify"}
                              </a>
                              <div style={{ color: "red" }}>
                                {this.state.verifyGSTINError ||
                                  (this.state.entityDetails
                                    .gstin_verify_return === ""
                                    ? ""
                                    : this.state.entityDetails
                                        .gstin_verify_return)}
                              </div>
                            </>
                          )}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell style={{ border: "none" }}>PAN : </TableCell>
                        <TableCell style={{ border: "none" }}>
                          {this.state.entityDetails.pan}
                        </TableCell>
                        <TableCell style={{ border: "none" }}>
                          {this.state.panLoader === true ? (
                            <CircularProgress size={30} thickness={5} />
                          ) : (
                            <>
                              <a
                                href="javscript:void(0)"
                                style={{ textDecoration: "none" }}
                                onClick={this.handleVerifyPAN}
                              >
                                {this.state.verifyPAN ||
                                this.state.entityDetails.is_pan_verified
                                  ? "Verified - Verify Again"
                                  : "Verify"}
                              </a>
                              <div style={{ color: "red" }}>
                                {this.state.verifyPANError ||
                                  (this.state.entityDetails
                                    .pan_verify_return === ""
                                    ? ""
                                    : this.state.entityDetails
                                        .pan_verify_return)}
                              </div>
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell style={{ minWidth: 180, border: "none" }}>
                          CIN :{" "}
                        </TableCell>
                        <TableCell style={{ border: "none" }}>
                          {this.state.entityDetails.cin}
                        </TableCell>
                        <TableCell style={{ border: "none" }}>
                          {this.state.cinLoader === true ? (
                            <CircularProgress size={30} thickness={5} />
                          ) : (
                            <>
                              <a
                                href="javscript:void(0)"
                                style={{ textDecoration: "none" }}
                                onClick={this.handleVerifyCIN}
                              >
                                {this.state.verifyCIN ||
                                this.state.entityDetails.is_cin_verified
                                  ? "Verified - Verify Again"
                                  : "Verify"}
                              </a>
                              <div style={{ color: "red" }}>
                                {this.state.verifyCINError ||
                                  (this.state.entityDetails
                                    .cin_verify_return === ""
                                    ? ""
                                    : this.state.entityDetails
                                        .cin_verify_return)}
                              </div>
                            </>
                          )}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell style={{ minWidth: 180, border: "none" }}>
                          MSME :
                        </TableCell>
                        <TableCell style={{ border: "none" }}>
                          {this.state.entityDetails.msme_flag}
                        </TableCell>
                        <TableCell style={{ border: "none" }}></TableCell>
                      </TableRow>

                  <TableRow>
                    <TableCell style={{ minWidth: 180, border: "none" }}>
                      CA FIRM :
                    </TableCell>
                    <TableCell style={{ border: "none" }}>
                      <FormControl fullWidth size="small">
                        <Select
                          size="small"
                          value={this.state.entityDetails?.is_ca_firm_or_not ? "Yes" : "No"}
                          onChange={this.handleDropdownChange}
                        >
                          <MenuItem value="Yes">Yes</MenuItem>
                          <MenuItem value="No">No</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                        <TableCell style={{ border: "none" }}>
                          {this.state.entityDetails?.is_ca_firm_or_not === true && (
                            <button
                              className="button-outlined-primary"
                              style={{ whiteSpace: "nowrap" }}
                              onClick={this.handleOpenUploadQuota}
                            >
                              Upload Quota
                            </button>
                          )}
                        </TableCell>
                      </TableRow>

                      {this.state.entityDetails?.is_ca_firm_or_not === true && (
                        <TableRow>
                          <TableCell style={{ minWidth: 180, border: "none" }}></TableCell>
                    <TableCell style={{ border: "none" }}></TableCell>
                          <TableCell style={{ border: "none" }}>
                            <button
                              className="button-outlined-primary"
                              style={{ whiteSpace: "nowrap" }}
                              onClick={this.handleOpenEntitiesUnderCaFirm}
                            >
                              Companies Under CA Firm
                            </button>
                          </TableCell>
                  </TableRow>
                      )}

                  {this.state.entityDetails?.is_ca_firm_or_not === false && (
                    <TableRow>
                      <TableCell style={{ minWidth: 180, border: "none" }}>
                        IS UNDER CA FIRM :
                      </TableCell>
                      <TableCell style={{ border: "none" }}>
                        <FormControl fullWidth size="small">
                          <Select
                            size="small"
                            value={this.state.selectedCaFirmEntity}
                            onChange={this.handleCaFirmEntityChange}
                            onOpen={this.handleCaFirmDropdownOpen}
                            displayEmpty
                          >
                            <MenuItem value="">
                              <em>Select CA Firm</em>
                            </MenuItem>
                            {this.state.caFirmEntities && this.state.caFirmEntities.length > 0 ? (
                              this.state.caFirmEntities.map((entity, index) => {
                                const entityId = typeof entity === 'string' ? entity : (entity.business_entity_id || entity.entity_name);
                                const entityName = typeof entity === 'string' ? entity : (entity.entity_name || entity.business_entity_id || 'Unnamed Entity');
                                
                                console.log('Rendering entity:', { entityId, entityName, entity });
                                
                                return (
                                  <MenuItem 
                                    key={entityId || index} 
                                    value={entityId}
                                  >
                                    {entityName}
                                  </MenuItem>
                                );
                              })
                            ) : (
                              <MenuItem disabled>
                                <em>No CA firms available</em>
                              </MenuItem>
                            )}
                          </Select>
                        </FormControl>
                      </TableCell>
                      <TableCell style={{ border: "none" }}></TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>

            {/* Services */}

            <div style={{ borderBottom: "2px solid #ddd", marginTop: "20px" }}>
              <h5 style={{ fontFamily: "Dosis", fontWeight: "550" }}>
                Services
              </h5>
            </div>
            <div style={{ marginBottom: "50px" }}>
              <div>
                <ServicesTable />
              </div>
            </div>
          </BoxWrapper>
        </div>

            {this.state.showEntitiesUnderCaFirmModal && (
          <div
            style={{
              position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
              backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999,
              display: "flex", alignItems: "center", justifyContent: "center"
            }}
            onClick={this.handleCloseEntitiesUnderCaFirm}
          >
            <div
              style={{
                background: "#fff", borderRadius: "8px", width: "80vw", maxWidth: "900px",
                maxHeight: "85vh", display: "flex", flexDirection: "column",
                border: "1px solid #d0d5dd", overflow: "hidden"
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div style={{
                background: "#1a3c5e", padding: "12px 20px",
                display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0
              }}>
                <span style={{ color: "#fff", fontSize: "14px", fontWeight: 500, display: "flex", alignItems: "center", gap: "8px" }}>
                  Companies under CA firm
                  <span style={{
                    background: "rgba(255,255,255,0.2)", color: "#fff",
                    fontSize: "12px", padding: "1px 9px", borderRadius: "12px"
                  }}>
                    {this.state.entitiesUnderCaFirm.length}
                  </span>
                </span>
                <button onClick={this.handleCloseEntitiesUnderCaFirm}
                  style={{
                    background: "transparent", border: "1px solid rgba(255,255,255,0.35)",
                    color: "#fff", fontSize: "12px", padding: "4px 14px",
                    borderRadius: "5px", cursor: "pointer"
                  }}>
                  Close
                </button>
              </div>

              {/* Search */}
              <div style={{ padding: "10px 16px", borderBottom: "1px solid #e8eaed", flexShrink: 0 }}>
                <input
                  type="text"
                  placeholder="Search by entity name or GSTIN..."
                  value={this.state.entitiesSearchQuery || ""}
                  onChange={(e) => this.setState({ entitiesSearchQuery: e.target.value })}
                  style={{
                    width: "100%", padding: "7px 12px", border: "1px solid #d0d5dd",
                    borderRadius: "5px", fontSize: "13px", boxSizing: "border-box",
                    outline: "none", background: "#fafbfc", color: "#333"
                  }}
                />
              </div>

              {/* Table */}
              <div style={{ overflowY: "auto", flex: 1 }}>
                <TableContainer component={Paper} elevation={0}>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        {[["SI NO.", "auto"], ["Entity name", "auto"], ["GSTIN", "auto"]].map(([label, w]) => (
                          <TableCell key={label} style={{
                            width: w, background: "#f4f6f8",
                            fontWeight: 800, color: "#1a2e3d", fontSize: "11px",
                            letterSpacing: "0.6px", textTransform: "uppercase",
                            borderBottom: "1px solid #e8eaed"
                          }}>{label}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(() => {
                        const query = (this.state.entitiesSearchQuery || "").toLowerCase();
                        const filtered = this.state.entitiesUnderCaFirm.filter(e =>
                          (e.business_entity_name || "").toLowerCase().includes(query) ||
                          (e.gstin || "").toLowerCase().includes(query)
                        );
                        return filtered.length > 0 ? filtered.map((entity, i) => (
                          <TableRow key={entity.business_entity_id} hover>
                            <TableCell style={{ color: "#1a2e3d", fontSize: "12px" }}>{i + 1}</TableCell>
                            <TableCell style={{ color: "#1a2e3d", fontSize: "13px" }}>{entity.business_entity_name}</TableCell>
                            <TableCell style={{ fontFamily: "monospace", fontSize: "12px", color: "#5a6a7a", letterSpacing: "0.3px" }}>{entity.gstin}</TableCell>
                          </TableRow>
                        )) : (
                          <TableRow>
                            <TableCell colSpan={3} style={{ textAlign: "center", color: "#1a2e3d", padding: "36px", fontSize: "13px", fontWeight: 500, }}>
                              No results found
                            </TableCell>
                          </TableRow>
                        );
                      })()}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>

              {/* Footer */}
              <div style={{
                padding: "9px 16px", background: "#f4f6f8",
                borderTop: "1px solid #e8eaed", flexShrink: 0, textAlign: "right"
              }}>
                <span style={{ fontSize: "12px", color: "#9aabb8" }}>
                  {this.state.entitiesUnderCaFirm.length} {this.state.entitiesUnderCaFirm.length === 1 ? "entity" : "entities"}
                </span>
              </div>
            </div>
          </div>
        )}
          

          {/* ASSIGN SERVICE FOR USER V.1.O*/}
          {/* <div className={classes.paperHeader}>User Services V.1.O</div>
          <div style={{ marginBottom: "100px" }}>
            <ValidatorForm
              ref="form"
              onSubmit={this.AssignServiceSubmitHandler}
              onError={(errors) => console.log(errors)}
            >
              <Grid
                container
                spacing={3}
                style={{
                  paddingLeft: "30px",
                  marginTop: "5px",
                }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12}>
               
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={this.handleIDCheckBoxChange}
                          name="checkedB"
                          color="primary"
                          checked={this.state.showIDData}
                        />
                      }
                      label="Invoice Discounting"
                    />
                  </Grid>
                </Grid>
                {this.state.showIDData && (
                  <Grid
                    container
                    spacing={3}
                    style={{ paddingLeft: "40px", paddingRight: "40px" }}
                  >
                    <Grid item xs>
                      <SelectField
                        SelectLabel="Status"
                        choice_id="ID_status_name"
                        choice_name="ID_status_name"
                        choices={[
                          {
                            ID_status_id: "1",
                            ID_status_name: "Not Requested",
                          },
                          { ID_status_id: "2", ID_status_name: "Approved" },
                          { ID_status_id: "3", ID_status_name: "Rejected" },
                          { ID_status_id: "4", ID_status_name: "Stop" },
                          { ID_status_id: "5", ID_status_name: "Hold" },
                          { ID_status_id: "6", ID_status_name: "Pending" },
                        ]}
                        name="ID_status"
                        value={
                          this.state.ID_ServiceData.status ?? "Not Requested"
                        }
                        validator={["required"]}
                        requiredField="*"
                        errorMsg={["This field is required"]}
                        textOnchangeFunction={this.handleEntityServiceChange}
                      />
                    </Grid>
                    {this.state.showIDFromDate && (
                      <Grid item xs>
                        <div style={{ marginTop: "20px" }}>
                          <label>
                            From Date
                            <span style={{ color: "red" }}>*</span>:
                          </label>
                          <ValidatedDatePicker
                            name="ID_from_date"
                            maxDate={this.state.ID_ServiceData.to_date ?? ""}
                            value={this.state.ID_ServiceData.from_date ?? ""}
                            onChange={(v) =>
                              this.handleFromDateChange(v, "ID_from_date")
                            }
                            inputProps={{ readOnly: true }}
                            validators={["required"]}
                            errorMessages={["Date is required"]}
                          />
                        </div>
                      </Grid>
                    )}
                    {this.state.showIDToDate && (
                      <Grid item xs>
                        <div style={{ marginTop: "20px" }}>
                          <label>
                            To Date
                            <span style={{ color: "red" }}>*</span>:
                          </label>
                          <ValidatedDatePicker
                            minDateForDatepicker={
                              this.state.ID_ServiceData.from_date
                            }
                            name="to_date"
                            value={this.state.ID_ServiceData.to_date ?? ""}
                            onChange={(v) =>
                              this.handleToDateChange(v, "ID_to_date")
                            }
                            validators={["required"]}
                            inputProps={{ readOnly: true }}
                            errorMessages={["Date is required"]}
                          />
                        </div>
                      </Grid>
                    )}
                    {this.state.showIDReason && (
                      <Grid item xs>
                        <InputField
                          inputType="text"
                          textLabel="Reason"
                          name="ID_reason"
                          value={this.state.ID_ServiceData.reason ?? ""}
                          textOnchangeFunction={this.handleEntityServiceChange}
                        />
                      </Grid>
                    )}
                  </Grid>
                )}
               
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                 
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={this.handleICCheckBoxChange}
                          name="checkedB"
                          color="primary"
                          checked={this.state.showICData}
                        />
                      }
                      label="Invoice Collection"
                    />
                  </Grid>
                </Grid>
                {this.state.showICData && (
                  <Grid
                    container
                    spacing={3}
                    style={{ paddingLeft: "40px", paddingRight: "40px" }}
                  >
                    <Grid item xs>
                      <SelectField
                        SelectLabel="Status"
                        choice_id="IC_status_name"
                        choice_name="IC_status_name"
                        name="IC_status"
                        choices={[
                          {
                            IC_status_id: "1",
                            IC_status_name: "Not Requested",
                          },
                          { IC_status_id: "2", IC_status_name: "Approved" },
                          { IC_status_id: "3", IC_status_name: "Rejected" },
                          { IC_status_id: "4", IC_status_name: "Stop" },
                          { IC_status_id: "5", IC_status_name: "Hold" },
                          { IC_status_id: "6", IC_status_name: "Pending" },
                        ]}
                        value={
                          this.state.IC_ServiceData.status ?? "Not Requested"
                        }
                        validator={["required"]}
                        requiredField="*"
                        errorMsg={["This field is required"]}
                        textOnchangeFunction={this.handleEntityServiceChange}
                      />
                    </Grid>
                    {this.state.showICFromDate && (
                      <Grid item xs>
                        <div style={{ marginTop: "20px" }}>
                          <label>
                            From Date
                            <span style={{ color: "red" }}>*</span>:
                          </label>
                          <ValidatedDatePicker
                            name="ic_from_date"
                            inputProps={{ readOnly: true }}
                            maxDate={this.state.IC_ServiceData.to_date ?? ""}
                            value={this.state.IC_ServiceData.from_date ?? ""}
                            onChange={(v) =>
                              this.handleFromDateChange(v, "ic_from_date")
                            }
                            validators={["required"]}
                            errorMessages={["Date is required"]}
                          />
                        </div>
                      </Grid>
                    )}
                    {this.state.showICToDate && (
                      <Grid item xs>
                        <div style={{ marginTop: "20px" }}>
                          <label>
                            To Date
                            <span style={{ color: "red" }}>*</span>:
                          </label>
                          <ValidatedDatePicker
                            minDateForDatepicker={
                              this.state.IC_ServiceData.from_date
                            }
                            name="ic_to_date"
                            inputProps={{ readOnly: true }}
                            value={this.state.IC_ServiceData.to_date ?? ""}
                            onChange={(v) =>
                              this.handleToDateChange(v, "ic_to_date")
                            }
                            validators={["required"]}
                            errorMessages={["Date is required"]}
                          />
                        </div>
                      </Grid>
                    )}
                    {this.state.showICReason && (
                      <Grid item xs>
                        <InputField
                          inputType="text"
                          textLabel="Reason"
                          name="ic_reason"
                          value={this.state.IC_ServiceData.reason ?? ""}
                          textOnchangeFunction={this.handleEntityServiceChange}
                        />
                      </Grid>
                    )}
                  </Grid>
                )}
               
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={this.handleARCCheckBoxChange}
                          name="checkedB"
                          color="primary"
                          checked={this.state.showARCData}
                        />
                      }
                      label="ARC (Accounting, Reconciliation & Compliance)"
                    />
                  </Grid>
                </Grid>
                {this.state.showARCData && (
                  <>
                    <Grid container spacing={3}></Grid>

                    <Grid
                      container
                      spacing={3}
                      style={{ paddingLeft: "40px", paddingRight: "40px" }}
                    >
                      <Grid item xs>
                        <SelectField
                          SelectLabel="Status"
                          choice_id="arc_status_name"
                          choice_name="arc_status_name"
                          name="arc_status"
                          choices={[
                            {
                              arc_status_id: "1",
                              arc_status_name: "Not Requested",
                            },
                            {
                              arc_status_id: "2",
                              arc_status_name: "Approved",
                            },
                            { arc_status_id: "3", arc_status_name: "Rejected" },
                            { arc_status_id: "4", arc_status_name: "Stop" },
                            { arc_status_id: "5", arc_status_name: "Hold" },
                            {
                              arc_status_id: "6",
                              arc_status_name: "Pending",
                            },
                          ]}
                          value={
                            this.state.ARC_ServiceData.status ?? "Not Requested"
                          }
                          validator={["required"]}
                          requiredField="*"
                          errorMsg={["This field is required"]}
                          textOnchangeFunction={this.handleEntityServiceChange}
                        />
                      </Grid>
                      {this.state.showARCFromDate && (
                        <Grid item xs>
                          <div style={{ marginTop: "20px" }}>
                            <label>
                              From Date
                              <span style={{ color: "red" }}>*</span>:
                            </label>
                            <ValidatedDatePicker
                              name="arc_from_date"
                              inputProps={{ readOnly: true }}
                              maxDate={this.state.ARC_ServiceData.to_date ?? ""}
                              value={this.state.ARC_ServiceData.from_date ?? ""}
                              onChange={(v) => this.handleFromDateChange(v)}
                              validators={["required"]}
                              errorMessages={["Date is required"]}
                            />
                          </div>
                        </Grid>
                      )}
                      {this.state.showARCToDate && (
                        <Grid item xs>
                          <div style={{ marginTop: "20px" }}>
                            <label>
                              To Date
                              <span style={{ color: "red" }}>*</span>:
                            </label>
                            <ValidatedDatePicker
                              minDateForDatepicker={
                                this.state.ARC_ServiceData.from_date
                              }
                              name="arc_to_date"
                              inputProps={{ readOnly: true }}
                              value={this.state.ARC_ServiceData.to_date ?? ""}
                              onChange={(v) => this.handleToDateChange(v)}
                              validators={["required"]}
                              errorMessages={["Date is required"]}
                            />
                          </div>
                        </Grid>
                      )}
                      {this.state.showARCReason && (
                        <Grid item xs>
                          <InputField
                            inputType="text"
                            textLabel="Reason"
                            name="arc_reason"
                            value={this.state.ARC_ServiceData.reason ?? ""}
                            textOnchangeFunction={
                              this.handleEntityServiceChange
                            }
                          />
                        </Grid>
                      )}
                    </Grid>
                  </>
                )}
              
              </Grid>
              <Button
                style={{ marginTop: "20px" }}
                variant="contained"
                size="small"
                type="submit"
               
              >
                save
              </Button>
            </ValidatorForm>
          </div> */}
        {/* </div> */}

        {/* ---Footer--- */}
        <div>
          <Footer />
        </div>
        {/* ---Footer End--- */}
        <UploadQuotaModal
          open={this.state.showUploadQuotaModal}
          onClose={this.handleCloseUploadQuota}
          entityId={this.state.business_entity_id}
        />
      </>
    );
  }
}

export default withStyles(useStyles, { withTheme: true })(AssignServices);